<div class="page-title">
  <h1>Ajuda e suporte</h1>
</div>

<div class="active-tag">
  <button [ngClass]="{'active-btn': isFaqActive}" (click)="toggleActiveScreen(true)">Dúvidas frequentes
  </button>
  <button [ngClass]="{'active-btn': !isFaqActive}" (click)="toggleActiveScreen(false)">Entre em contato
  </button>
</div>

<app-faq-questions *ngIf="isFaqActive"></app-faq-questions>
<app-faq-contact *ngIf="!isFaqActive"></app-faq-contact>

